module.exports = __webpack_public_path__ + "img/ms.msdd5003c.svg";